import { Text, TextField } from '@/components/design-system'

interface OrganizationData {
  organization_name: string
  website_url: string
  industry: string
  company_size: string
}

interface Props {
  data: OrganizationData
  onChange: (field: keyof OrganizationData, value: string) => void
}

const INDUSTRIES = [
  'Moda e Vestuário',
  'Saúde e Beleza',
  'Alimentos e Bebidas',
  'Casa e Decoração',
  'Eletrônicos',
  'Esportes e Suplementos',
  'Pet Shop',
  'Brinquedos e Bebês',
  'Joias e Acessórios',
  'Automotivo',
  'Outro',
]

const COMPANY_SIZES = ['Só eu', '2-5', '6-20', '21-50', '50+']

export default function OrganizationStep({ data, onChange }: Props) {
  return (
    <div className="space-y-8">
      <div>
        <Text as="h1" size="display-small" className="font-bold text-foreground">
          Sobre sua empresa
        </Text>
        <Text as="p" size="body-large" color="subdued" className="mt-2">
          Conte um pouco sobre sua operação.
        </Text>
      </div>

      <div className="space-y-6">
        <TextField
          label="Nome da organização"
          value={data.organization_name}
          onChange={(value) => onChange('organization_name', value)}
          placeholder="Winterfell Inc."
          required
          autoComplete="organization"
        />

        <TextField
          label="Website da empresa"
          value={data.website_url}
          onChange={(value) => onChange('website_url', value)}
          placeholder="https://suaempresa.com.br"
          type="url"
          required
        />

        <div>
          <Text as="label" size="body-small" className="mb-3 block font-medium text-muted-foreground">
            Setor de atuação
          </Text>
          <div className="flex flex-wrap gap-2">
            {INDUSTRIES.map((industry) => (
              <button
                key={industry}
                type="button"
                onClick={() => onChange('industry', industry)}
                className={`rounded-full border px-4 py-2 text-sm font-medium transition-colors ${
                  data.industry === industry
                    ? 'border-border bg-accent text-foreground'
                    : 'border-border bg-background text-muted-foreground hover:border-border hover:bg-accent'
                }`}
              >
                {industry}
              </button>
            ))}
          </div>
        </div>

        <div>
          <Text as="label" size="body-small" className="mb-3 block font-medium text-muted-foreground">
            Tamanho da equipe
          </Text>
          <div className="flex flex-wrap gap-2">
            {COMPANY_SIZES.map((size) => (
              <button
                key={size}
                type="button"
                onClick={() => onChange('company_size', size)}
                className={`rounded-full border px-4 py-2 text-sm font-medium transition-colors ${
                  data.company_size === size
                    ? 'border-border bg-accent text-foreground'
                    : 'border-border bg-background text-muted-foreground hover:border-border hover:bg-accent'
                }`}
              >
                {size === 'Só eu' ? size : `${size} pessoas`}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
